import React from 'react';
import '../styles/Testimonials.css';
import '../styles/ScrollAnimation.css';
import ScrollAnimation from '../utils/ScrollAnimation';

const TESTIMONIALS = [
  {
    quote:
      'I had the pleasure of working with Muqeet on a complex project involving a Chrome extension built with React and Django. The task required modifying the frontend to handle Markdown properly and updating the backend API responses accordingly. Muqeet demonstrated excellent technical expertise and was always willing to clarify any doubts or issues that arose during the process. He went the extra mile by not only implementing the requested changes but also ensuring the entire extension worked seamlessly. Even when we encountered issues with other developers’ work, Muqeet was quick to step in and provide solutions. I would highly recommend him for any web development projects, especially those that involve complex integrations and multiple technologies.',
    name: 'Junio Borges',
    role: 'Owner',
    company: 'Taylor drop',
    rating: 5,
  },
  {
    quote:
      'Muqeet supported me in developing the MVP for my platform, covering both frontend and backend with Django/React, profile creation flows, admin dashboard, multilingual setup, and deployment under a live domain. He was always responsive, collaborative, and made sure all key features were delivered as agreed. Wording refinements and frontend alignment sometimes required a few iterations, but this also helped us reach a very polished result in the end. Overall, I was really happy with Muqeet’s work and professionalism, and I very likely will engage him again for follow-on projects. Highly recommended.',
    name: 'Julian',
    role: 'Founder & Co-CEO',
    company: 'Businessmajli',
    rating: 4.9,
  },
  {
    quote:
      'Outstanding execution, Muqeet. You handled every task with precision and consistency. Really impressed with the quality of your work and the smooth communication throughout.',
    name: 'Nandit',
    role: 'Founder',
    company: 'Craftposition',
    rating: 5,
  },
  {
    quote:
      'Detail oriented, faster and smarter than I thought. I will definitely work with Muqeet again!',
    name: 'Brandon Inniss',
    role: 'CEO',
    company: 'Ganarpro',
    rating: 5,
  },
  {
    quote: 'Top work! I’m super happy! I can recommend him 100%!',
    name: 'Roman Bühler',
    role: 'CEO & Founder',
    company: 'Movsentry',
    rating: 5,
  },
  {
    quote: 'Very great work, and easy to talk with! Looking forward to do more gigs with him.',
    name: 'Andrew Moshi',
    role: 'Owner',
    company: 'Tupo Hapa',
    rating: 5,
  },
  {
    quote: 'The work was completed in an excellent way. Very responsive and delivered good work.',
    name: 'Kelvin Tay',
    role: 'Owner',
    company: 'LabeauPos',
    rating: 5,
  },
  {
    quote: 'Super good — his work is really worth it.',
    name: 'Jay',
    role: 'Manager',
    company: 'Magnoliacake',
    rating: 5,
  },
];

const renderStars = (rating = 5) => {
  const filled = Math.min(5, Math.round(rating));
  return `${'★'.repeat(filled)}${'☆'.repeat(5 - filled)}`;
};

const Testimonials = () => {
  const featured = TESTIMONIALS.slice(0, 2);
  const rest = TESTIMONIALS.slice(2);

  const renderCard = (item, index) => (
    <ScrollAnimation key={item.name} className={`fade-up stagger-${(index % 4) + 1}`}>
      <blockquote className="testimonial-card">
        <div className="testimonial-rating">
          <span className="testimonial-stars" aria-hidden="true">
            {renderStars(item.rating)}
          </span>
          <span className="testimonial-score">{item.rating.toFixed(1)}</span>
        </div>
        <p className="testimonial-quote">{item.quote}</p>
        <footer className="testimonial-footer">
          <div className="testimonial-avatar">{item.name.slice(0, 1)}</div>
          <div>
            <cite className="testimonial-name">{item.name}</cite>
            <span className="testimonial-meta">
              {item.role}
              <br />
              {item.company}
            </span>
          </div>
        </footer>
      </blockquote>
    </ScrollAnimation>
  );

  return (
    <section id="testimonials" className="testimonials section">
      <div className="container">
        <ScrollAnimation className="fade-up">
          <div className="testimonials-header">
            <h2 className="section-title">Testimonials</h2>
            <div className="divider-glow" />
            <p className="section-subtitle">
              Client reviews from Fiverr after successful deliveries.
            </p>
          </div>
        </ScrollAnimation>

        <div className="testimonials-layout">
          <div className="testimonials-row testimonials-row--featured">
            {featured.map((item, index) => renderCard(item, index))}
          </div>
          {rest.length > 0 && (
            <div className="testimonials-row testimonials-row--grid">
              {rest.map((item, index) => renderCard(item, index + 2))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
